module.exports = __webpack_public_path__ + "web/img/txt.cde0b08b.png";